import $ from 'jquery';
import {checkForWrongEventTarget} from './checkForWrongEventTarget';

export class Checkbox {
  constructor(domNode, onChange) {
    this.domNode = domNode;
    this.checkboxInput = this.domNode.getElementsByTagName('input')[0];
    this.textInput = domNode.querySelector('.input-element');
    this.onChange = onChange;
    this.domNode.tabIndex = 0;
    this.wasCheckedBeforeDisabled = null;
    this.domNode.setAttribute('aria-checked', this.isChecked() ? 'true' : 'false');
    this.domNode.addEventListener('keydown', this.handleKeydown.bind(this));
    this.domNode.addEventListener('click', this.handleClick.bind(this));

    this.isChecked() && this.isVisible() ? this.setChecked() : this.setUnchecked();
  }

  isDisabled() {
    return this.checkboxInput.disabled;
  }

  isVisible() {
    return $(this.domNode).is(':visible');
  }

  isChecked() {
    return this.checkboxInput.checked;
  }

  setChecked() {
    this.checkboxInput.checked = true;
    this.setPropertiesForChecked();
    this.focusInputField();
  }

  setUnchecked() {
    this.checkboxInput.checked = false;
    this.setPropertiesForUnchecked();
  }

  toggleCheckbox(event) {
    if (this.isDisabled()) {
      return;
    }
    if (this.isChecked()) {
      this.setUnchecked();
    } else {
      this.setChecked();
    }
    this.onChange(event, this);
  }

  handleKeydown(event) {
    if (event.target == this.textInput) {
      if (!this.isChecked() && event.key != 'Tab') {
        this.setChecked();
      }
      return;
    }

    switch (event.key) {
      case ' ': //Spacebar
      case 'Spacebar': //for older Browsers
        this.toggleCheckbox(event);
        event.preventDefault();
        break;

      default:
        break;
    }
  }

  isAriaChecked() {
    return this.domNode.getAttribute('aria-checked') == 'true';
  }

  handleClick(event) {
    event.stopPropagation();
    if (checkForWrongEventTarget(event.target, 'checkbox')) {
      return;
    }

    if (this.isDisabled()) {
      return;
    }

    const isEventFromInput = event.target == this.textInput;
    const isSafari = isEventFromInput && event.toElement; // only safari sets toElement to an object (13.10.23)

    // we want to toggle if a checked option is clicked
    // we dont want to toggle if click event happened on the input field. then we want to set checkec
    // exception is VoiceOver - in Voice-over we want to toggle. reason:
    //    our html (nested input in label/role=radio) causes voice-over:
    //      - to send every event from this input
    //      - to make the input not accessable at all
    if (!this.isAriaChecked() || (isEventFromInput && !isSafari)) {
      this.setChecked();
    } else {
      this.setUnchecked();
    }

    this.onChange(event, this);
  }

  hasInputField() {
    return this.textInput !== null;
  }

  focusInputField() {
    if (this.hasInputField()) {
      this.textInput.focus();
    }
  }

  getValue() {
    return this.checkboxInput.value;
  }

  setDisabled() {
    this.checkboxInput.disabled = true;
    this.domNode.setAttribute('tabindex', -1);
    this.domNode.setAttribute('disabled', 'disabled');
    this.domNode.setAttribute('aria-disabled', true);
    this.checkboxInput.setAttribute('disabled', 'disabled');
    this.checkboxInput.setAttribute('aria-disabled', true);
    if (this.textInput) {
      this.textInput.disabled = true;
      this.textInput.setAttribute('tabindex', -1);
      this.textInput.setAttribute('aria-disabled', true);
    }
    if (this.wasCheckedBeforeDisabled === null) {
      this.wasCheckedBeforeDisabled = this.isChecked();
    }
    this.setUnchecked();
  }

  setEnabled() {
    this.checkboxInput.disabled = false;
    this.domNode.setAttribute('tabindex', 0);
    this.domNode.removeAttribute('disabled');
    this.domNode.removeAttribute('aria-disabled');
    this.checkboxInput.removeAttribute('disabled');
    this.checkboxInput.removeAttribute('aria-disabled');
    if (this.textInput) {
      this.textInput.disabled = false;
      this.textInput.setAttribute('tabindex', 0);
      this.textInput.removeAttribute('aria-disabled');
    }

    if (this.wasCheckedBeforeDisabled) {
      this.setChecked();
    }
    this.wasCheckedBeforeDisabled = null;
  }

  setPropertiesForChecked() {
    this.domNode.setAttribute('aria-checked', 'true');
    this.domNode.classList.add('option-checked');

    if (this.hasInputField()) {
      this.textInput.setAttribute('tabindex', 0);
    }
  }

  setPropertiesForUnchecked() {
    this.domNode.setAttribute('aria-checked', 'false');
    this.domNode.classList.remove('option-checked');

    if (this.hasInputField()) {
      this.textInput.setAttribute('tabindex', -1);
    }
  }
}
